// extracted by mini-css-extract-plugin
module.exports = {"statusTitle":"styles_statusTitle__1jvlY","mobileStatus":"styles_mobileStatus__PgXhM","desktopStatus":"styles_desktopStatus__1ii51","title":"styles_title__2aeGT"};